import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface TenantUserFormPayload {
  tenant_id: number;
  name: string;
  email: string;
  phone?: string;
  role: 'owner' | 'admin' | 'member';
  notes?: string;
}

const list = (payload: { tenantId?: number | string } = {}) => {
  const params: Record<string, string> = {};
  if (payload.tenantId) params.tenantId = String(payload.tenantId);
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.tenantUsers}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.tenantUsers}/${id}`);

const create = (payload: TenantUserFormPayload) => http.post(API_ENDPOINTS.tenantUsers, payload);

const update = (id: number | string, payload: Partial<Omit<TenantUserFormPayload, 'tenant_id'>>) =>
  http.patch(`${API_ENDPOINTS.tenantUsers}/${id}`, payload);

const reinvite = (id: number | string) => http.post(`${API_ENDPOINTS.tenantUsers}/${id}/reinvite`);

const deactivate = (id: number | string, reason?: string) =>
  http.patch(`${API_ENDPOINTS.tenantUsers}/${id}/deactivate`, { reason });

const remove = (id: number | string, reason: string) =>
  http.delete(`${API_ENDPOINTS.tenantUsers}/${id}`, { data: { reason } });

const validateToken = (token: string) => http.get(`${API_ENDPOINTS.tenantUserValidateToken}/${token}`);

const activate = (token: string, password: string) =>
  http.post(`${API_ENDPOINTS.tenantUserActivate}/${token}`, { password });

const TenantUserService = { list, get, create, update, reinvite, deactivate, remove, validateToken, activate };

export default TenantUserService;
